import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { App } from './App';
import { BrandingProvider } from './branding/BrandingProvider';
import { ErrorBoundary } from './components/ErrorBoundary';
import { PrintPage } from './screens/PrintPage';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root não encontrado.');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <BrandingProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/print/:reportId" element={<PrintPage />} />
          </Routes>
        </BrowserRouter>
      </BrandingProvider>
    </ErrorBoundary>
  </StrictMode>,
);
